export default __webpack_public_path__ + "static/media/managu.c74e8107.svg";